// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"home-module--imgContainer--3aXLw","img":"home-module--img--1BfZU"};